export default __webpack_public_path__ + "static/media/l12.bb1b94cf.png";